import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import R1seModal from '../projects_templates/r1se/modal';
import AcropliaModal from '../projects_templates/acroplia/modal';
import NomadCalendarModal from '../projects_templates/nomadcalendar/modal';
import GoodGanttModal from '../projects_templates/goodgantt/modal';
import HrNetworkModal from '../projects_templates/hrnetwork/modal';
import CsvParserModal from '../projects_templates/csvparser/modal';
import TravelShopModal from '../projects_templates/travelshop/modal';
import StaffModal from '../projects_templates/staff/modal';
import VkReactFilterModal from '../projects_templates/vk_react_filter/modal';
import PoynthqModal from '../projects_templates/poynthq/modal';
import EnglishBuddyModal from '../projects_templates/english_buddy/modal';
import PizzaAppModal from '../projects_templates/pizza_app/modal';
import SedonaModal from '../projects_templates/sedona/modal';
import AutoServiceModal from '../projects_templates/auto21/modal';
import GllacyModal from '../projects_templates/gllacy/modal';
import SimpleChatModal from '../projects_templates/chat/modal';
import SnakeGameModal from '../projects_templates/snake/modal';
import VueStockModal from '../projects_templates/vue-stock/modal';
import ElectronModal from '../projects_templates/electron_webp_converter/modal';

class ProjectModal extends Component {
	async componentDidMount() {
		document.addEventListener('click', this.handleClick);
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClick);
	}

	handleClick = (event) => {
		const { closeModal } = this.props;
		if (!event.target.closest('.project-popup')) {
			closeModal();
		}
	};

	renderProjectModal = () => {
		const { projectName, closeModal, isModalOpened } = this.props;
		let Modal = null;
		switch (projectName) {
			case 'r1se':
				Modal = R1seModal;
				break;
			case 'acroplia':
				Modal = AcropliaModal;
				break;
			case 'nomadcalendar':
				Modal = NomadCalendarModal;
				break;
			case 'goodgantt':
				Modal = GoodGanttModal;
				break;
			case 'hrnetwork':
				Modal = HrNetworkModal;
				break;
			case 'electron_webp_converter':
				Modal = ElectronModal;
				break;
			case 'csvparser':
				Modal = CsvParserModal;
				break;
			case 'travelshop':
				Modal = TravelShopModal;
				break;
			case 'staff':
				Modal = StaffModal;
				break;
			case 'vk_react_filter':
				Modal = VkReactFilterModal;
				break;
			case 'poynthq':
				Modal = PoynthqModal;
				break;
			case 'english_buddy':
				Modal = EnglishBuddyModal;
				break;
			case 'pizza_app':
				Modal = PizzaAppModal;
				break;
			case 'sedona':
				Modal = SedonaModal;
				break;
			case 'auto21':
				Modal = AutoServiceModal;
				break;
			case 'gllacy':
				Modal = GllacyModal;
				break;
			case 'chat':
				Modal = SimpleChatModal;
				break;
			case 'snake':
				Modal = SnakeGameModal;
				break;
			case 'vue-stock':
				Modal = VueStockModal;
				break;
			default:
				Modal = null;
		}
		if (Modal)
			return <Modal isModalOpened={isModalOpened} closeModal={closeModal} />;
		return null;
	};

	render() {
		return (
			<React.Fragment>
				<div className='projects-popup-wrapper'>
					<ReactCSSTransitionGroup
						transitionName='fade'
						transitionAppear={true}
						transitionEnter={false}
						transitionLeave={false}
						transitionAppearTimeout={400}
					>
						{this.renderProjectModal()}
					</ReactCSSTransitionGroup>
				</div>
				<div className='overlay-fade'></div>
			</React.Fragment>
		);
	}
}

export default ProjectModal;
